import { useState, useEffect } from 'react'

const sameValue = (a, b) => String(a ?? '') === String(b ?? '')

/**
 * AI-OCR で反映した欄の強調
 *
 * 反映した値のままの欄を強調し、手で値を変えた欄は強調をやめる（時間では消さない）。
 * 新しく読み取って反映したら、前の強調は消えて新しい欄に置き換わる。
 *
 * @param {Function} watch react-hook-form の watch
 */
export default function useOcrHighlight (watch) {
  // 項目名 → 反映した値
  const [appliedValues, setAppliedValues] = useState({})
  const keys = Object.keys(appliedValues)
  const currentValues = keys.length > 0 ? watch(keys) : []

  useEffect(() => {
    const changed = keys.filter((key, i) => !sameValue(currentValues[i], appliedValues[key]))
    if (changed.length > 0) {
      setAppliedValues(prevState => Object.fromEntries(Object.entries(prevState).filter(([key]) => !changed.includes(key))))
    }
  }, [JSON.stringify(currentValues)])

  return {
    /** @param {Array<[string, any]>} applied 反映した項目と値 */
    highlight: (applied) => setAppliedValues(Object.fromEntries(applied)),
    /** @param {string[]} fieldKeys 1つの欄の項目名（登録番号のように複数のこともある） */
    isHighlighted: (fieldKeys) => fieldKeys.some(key => key in appliedValues)
  }
}
